module.exports = __webpack_public_path__ + "img/check_mark_white.d8bb7fbd.svg";